<template>
  <div
    class="not-found-container d-flex flex-column align-items-center justify-content-center"
  >
    <div class="not-found-content text-center">
      <div class="error-number">404</div>
      <h2 class="mb-3">{{ $t('common.pageNotFound') }}</h2>
      <p class="mb-4 text-muted">
        {{ $t('common.pageNotFoundDesc') }}
      </p>
      <button @click="irAInicio()" class="btn btn-pill btn-black px-4 py-2">
        {{ $t('common.backToHome') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    irAInicio() {
      window.location.href = "/";
    },
  },
};
</script>

<style lang="scss" scoped>
.not-found-container {
  min-height: 100vh;
  background-color: #ffffff;
  animation: fadeIn 0.6s ease-out;
}

.error-number {
  font-size: 10rem;
  font-weight: 800;
  color: black;
  margin-bottom: 1rem;
  opacity: 0;
  animation: floatIn 1s ease-out 0.2s forwards;
}

h2 {
  font-size: 2rem;
  color: black;
  opacity: 0;
  animation: fadeIn 0.8s ease-out 0.6s forwards;
}

p {
  font-size: 1.1rem;
  max-width: 600px;
  opacity: 0;
  animation: fadeIn 0.8s ease-out 0.9s forwards;
}

.btn-black {
    color: white;
  background-color: black ;
  border-color: black;
  opacity: 0;
  transform: translateY(10px);
  animation: slideUp 0.6s ease-out 1.2s forwards;
}

.btn-black:hover {
  background-color: white;
  border-color: black;
  color: black;
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes floatIn {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
